import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import NothingButNet from '@/components/uploader/nothing-but-net'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <section id='uploader' className='flex min-h-dvh w-full items-center justify-center overflow-clip bg-desk p-4'>
                <NothingButNet />
            </section>
        </Layout>
    )
}

export default Home
